import React, { useRef } from "react";
import AccessibleDialog from "../UI/Modals/AccessibleDialog/AccessibleDialog";
import styles from "./ConsultOrderPromptModal.module.scss";

// The two-choice step shown before opening either form (regular reservation
// vs RFZO request). The chip ALWAYS reopens this prompt (no mode is ever
// entered silently) and Escape/overlay/close simply decline (onClose): drafts
// and results are preserved behind the chip, nothing is discarded. Labels
// adapt to what already exists for this consult:
//   - order action: "Rezervacija" / "Nastavi rezervaciju";
//   - RFZO action:  "RFZO upit" / "Nastavi RFZO upit" (draft), or
//     "Pregled RFZO upita" (a request was sent -> view-only confirmation).
// ITAM-2887: the advisor only raises an empty RFZO request, so every RFZO
// result is terminal and the plain reservation is never disabled by it.

export type PromptRfzoState = "NONE" | "TERMINAL";

export interface ConsultOrderPromptModalProps {
  isOpen: boolean;
  callerName: string;
  cncFormVisited: boolean;
  rfzoFormVisited: boolean;
  rfzoState: PromptRfzoState;
  onConfirmOrder: () => void;
  onConfirmRfzo: () => void;
  onResumeRfzo: () => void;
  onClose: () => void;
}

const TITLE_ID = "consult-order-prompt-title";

const ConsultOrderPromptModal: React.FC<ConsultOrderPromptModalProps> = ({
  isOpen,
  callerName,
  cncFormVisited,
  rfzoFormVisited,
  rfzoState,
  onConfirmOrder,
  onConfirmRfzo,
  onResumeRfzo,
  onClose,
}) => {
  const orderRef = useRef<HTMLButtonElement>(null);

  const orderLabel = cncFormVisited ? "Nastavi rezervaciju" : "Rezervacija";

  const rfzoLabel =
    rfzoState === "TERMINAL"
      ? "Pregled RFZO upita"
      : rfzoFormVisited
      ? "Nastavi RFZO upit"
      : "RFZO upit";
  const rfzoAction = rfzoState === "NONE" ? onConfirmRfzo : onResumeRfzo;

  return (
    <AccessibleDialog
      isOpen={isOpen}
      onRequestClose={onClose}
      titleId={TITLE_ID}
      initialFocusRef={orderRef}
      maxWidth={440}
      closeButtonLabel="Zatvori"
    >
      <div className={styles.body}>
        <h2 id={TITLE_ID} className={styles.title}>
          Kreiranje za korisnika
        </h2>
        <p className={styles.message}>
          Šta želite da kreirate za {callerName}?
        </p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.secondary}
            onClick={onClose}
          >
            Otkaži
          </button>
          <button type="button" className={styles.rfzo} onClick={rfzoAction}>
            {rfzoLabel}
          </button>
          <button
            type="button"
            ref={orderRef}
            className={styles.primary}
            onClick={onConfirmOrder}
          >
            {orderLabel}
          </button>
        </div>
      </div>
    </AccessibleDialog>
  );
};

export default ConsultOrderPromptModal;
